import { useTranslation } from 'react-i18next';

export default function TableNotFound() {
  const { t } = useTranslation();
  return (
    <td className="w-full" colSpan={100}>
      <p className="py-4-0 text-center text-body1">{t('tables.no_result')}</p>
    </td>
  );
}
